import React from "react";

const applicantItems = [
  {
    label: <span>Applicant details</span>,
    url: '/{{form}}/applicant-detail',
    default: true,
  }]
  const qualificationItems = [
  {
    label: <span>Qualifications</span>,
    url: '/{{form}}/qualification',
    default: true,
  }]
  const associateItems = [
  {
    label: <span>Associates</span>,
    url: '/{{form}}/associate',
  }]
  const organisationItems = [
  {
    label: <span>Organisation details</span>,
    url: '/{{form}}/organisation',
  }]
  const projectItems = [
  {
    label: <span>Project details</span>,
    url: '/{{form}}/project-detail',
  }]
  const locationItems = [
  {
    label: <span>Location Data</span>,
    url: '/{{form}}/location',
  }]
  const focusOfWorkItems = [
  {
    label: <span>Focus of work</span>,
    url: '/{{form}}/focusofwork',
  }]
  const additionalInfoItems = [
  {
    label: <span>Additional information</span>,
    url: '/{{form}}/upload-document',
  }]
  const confirmationItems = [
  {
    label: <span>Confirm details</span>,
    url: '/{{form}}/review-application',
    step: 1
  },
  {
    label: <span>Declaration</span>,
    url: '/{{form}}/declaration',
    step: 2
  },
  {
    label: <span>Payment</span>,
    url: '/{{form}}/fee-breakdown',
    step: 3
  }
];

const importExportIndividualItems = [
  // {
  //   label: <span>Licence Information</span>,
  //   url: '/{{form}}/individual-licence-information',
  //   // default: true,
  // },
  {
    label: <span>Applicant details</span>,
    url: '/{{form}}/applicant-details',
    default: true,
  },
  // {
  //   label: <span>Organisation Details</span>,
  //   url: '/{{form}}/organisation-detail',
  // },  
  // {
  //   label: <span>Sample form 1</span>,
  //   url: '/{{form}}/sample-form-1',
  //   default: true,
  // },
  {
    label: <span>Interstate Person/Organisation</span>,
    url: '/{{form}}/individual-interstate-decision',
  },
  {
    label: <span>Interstate Person/Organisation Details</span>,
    url: '/{{form}}/interstate-individual',
  },
  {
    label: <span>Interstate Licence Details</span>,
    url: '/{{form}}/interstate-individual-licence',
  },
  {
    label: <span>Interstate Licence Details</span>,
    url: '/{{form}}/upload-document',
  },
  {
    label: <span>Confirm Details</span>,
    url: '/{{form}}/review-individual-application',
  },
  {
    label: <span>Declaration</span>,
    url: '/{{form}}/individual-declaration',
  },
  {
    label: <span>Payment</span>,
    url: '/{{form}}/individual-fee-breakdown',
  },  
];

const importExportOrganisationItems = [
  // {
  //   label: <span>Applicant Details</span>,
  //   url: '/{{form}}/applicant-detail',
  //   default: true,
  // },
  {
    label: <span>Organisation Details</span>,
    url: '/{{form}}/organisation-detail',
    default: true
  },  
  // {
  //   label: <span>Sample form 1</span>,
  //   url: '/{{form}}/sample-form-1',
  //   default: true,
  // },
  {
    label: <span>Interstate Person/Organisation</span>,
    url: '/{{form}}/organisation-interstate-decision',
  },
  {
    label: <span>Interstate Person/Organisation</span>,
    url: '/{{form}}/interstate-organisation',
  },
  {
    label: <span>Interstate Licence Details</span>,
    url: '/{{form}}/interstate-organisation-licence',
  },
  {
    label: <span>Confirm Details</span>,
    url: '/{{form}}/review-organisation-application',
  },  
  {
    label: <span>Declaration</span>,
    url: '/{{form}}/organisation-declaration',
  },
  {
    label: <span>Payment</span>,
    url: '/{{form}}/organisation-fee-breakdown',
  },  
];

const individualApplicantDetailsItems = [
  {
    label: <span>Applicant Details</span>,
    url: '/{{form}}/applicant-details',
    default: true,
    step: 1
  }
];


const interStateIndividualDecisionDetailsItems = [
  {
    label: <span>Interstate Person/Organisation</span>,
    url: '/{{form}}/individual-interstate-decision',
    default: true,
    step: 1
  },
  {
    label: <span>Interstate Person/Organisation Details</span>,
    url: '/{{form}}/interstate-individual',
    step: 2
  },  
];

const interStateIndividualDetailsItems = [
  {
    label: <span>Interstate Person/Organisation Details</span>,
    url: '/{{form}}/interstate-individual',
    default: true,
    step: 1
  },
];

const interStateIndividualLicenceDetailsItems = [
  {
    label: <span>Interstate Licence Details</span>,
    url: '/{{form}}/interstate-individual-licence',
    step: 1
  },
];

  const attachmentDetailsItems = [
  {
    label: <span>Proof of Identity</span>,
    url: '/{{form}}/upload-document',
  }]

const individualContactItems = [
  {
    label: <span>Confirm Details</span>,
    url: '/{{form}}/review-individual-application',
    default: true,
    step: 1
  },
  {
    label: <span>Declaration</span>,
    url: '/{{form}}/individual-declaration',
    step: 2
  },
  {
    label: <span>Payment</span>,
    url: '/{{form}}/individual-fee-breakdown',
    step: 3
  },  
];

const organisationApplicantDetailsItems = [
  {
    label: <span>Organisation Details</span>,
    url: '/{{form}}/organisation-licence-information',
    default: true,
    step: 1
  }
];

const interStateOrganisationDecisionDetailsItems = [
  {
    label: <span>Interstate Person/Organisation</span>,
    url: '/{{form}}/organisation-interstate-decision',
    default: true,
    step: 1
  },
  {
    label: <span>Interstate Person/Organisation Details</span>,
    url: '/{{form}}/interstate-organisation',
    default: true,
    step: 2
  },
];

const interStateOrganisationDetailsItems = [
  {
    label: <span>Interstate Person/Organisation Details</span>,
    url: '/{{form}}/interstate-organisation',
    default: true,
    step: 1
  },
];

const interStateOrganisationsLicenceDetailsItems = [
  {
    label: <span>Interstate Licence Details</span>,
    url: '/{{form}}/interstate-organisation-licence',
    default: true,
    step: 1
  },
];

const organisationContactItems = [
  {
    label: <span>Confirm Details</span>,
    url: '/{{form}}/review-organisation-application',
    default: true,
    step: 1
  },
  {
    label: <span>Declaration</span>,
    url: '/{{form}}/organisation-declaration',
    step: 2
  },
  {
    label: <span>Payment</span>,
    url: '/{{form}}/organisation-fee-breakdown',
    step: 3
  },  
];

const getStepNumberIndWithImportExportUrl = (url) =>{
  let stepNumber='step0';

  switch(url){
    case "/import-export/applicant-detail":{
      stepNumber="step1";
      break;
    }
    case "/import-export/individual-interstate-decision":{
      stepNumber="step2";
      break;
    }
    case "/import-export/interstate-individual":{
      stepNumber="step3";
      break;
    }
    case "/import-export/interstate-individual-licence":{
      stepNumber="step4";
      break;
    }
    case "/import-export/review-individual-application":{
      stepNumber="step5";
      break;
    }
    case "/import-export/individual-declaratio":{
      stepNumber="step6";
      break;
    }
    case "/import-export/individual-fee-breakdown":{
      stepNumber="step7";
      break;
    }
  }
  return stepNumber;
};

const getStepNumberOrgWithImportExportUrl = (url) =>{
  let stepNumber='step0';

  switch(url){
    case "/import-export/organisation-licence-information":{
      stepNumber="step1";
      break;
    }
    case "/import-export/organisation-interstate-decision":{
      stepNumber="step2";
      break;
    }
    case "/import-export/interstate-organisation":{
      stepNumber="step3";
      break;
    }
    case "/import-export/interstate-organisation-licence":{
      stepNumber="step4";
      break;
    }
    case "/import-export/review-organisation-application":{
      stepNumber="step5";
      break;
    }
    case "/import-export/organisation-declaratio":{
      stepNumber="step6";
      break;
    }
    case "/import-export/organisation-fee-breakdown":{
      stepNumber="step7";
      break;
    }
  }
  return stepNumber;
};

const getStepNumberWithFloraFaunaUrl = (url) => {

  let stepNumber='step0';
  
  switch(url){
    case "/flora-fauna/applicant-detail":{
      stepNumber="step1";
      break;
    }
    case "/flora-fauna/qualification":{
      stepNumber="step2";
      break;
    }
    case "/flora-fauna/associate":{
      stepNumber="step3";
      break;
    }
    case "/flora-fauna/organisation":{
      stepNumber="step4";
      break;
    }
    case "/flora-fauna/project-detail":{
      stepNumber="step5";
      break;
    }
    case "/flora-fauna/location":{
      stepNumber="step6";
      break;
    }
    case "/flora-fauna/focusofwork":{
      stepNumber="step7";
      break;
    }
    case "/flora-fauna/upload-document":{
      stepNumber="step8";
      break;
    }
    case "/flora-fauna/review-application":{
      stepNumber="step9";
      break;
    }
    case "/flora-fauna/declaration":{
      stepNumber="step10";
      break;
    }
    case "/flora-fauna/fee-breakdown":{
      stepNumber="step11";
      break;
    }
  }

  return stepNumber;
};

export {
  applicantItems,
  qualificationItems,
  organisationItems,
  associateItems,
  projectItems,
  locationItems,
  focusOfWorkItems,
  additionalInfoItems,
  confirmationItems,
  importExportIndividualItems,
  importExportOrganisationItems,
  individualApplicantDetailsItems,
  interStateIndividualDecisionDetailsItems,
  interStateIndividualDetailsItems,
  interStateIndividualLicenceDetailsItems,
  attachmentDetailsItems,
  interStateOrganisationDetailsItems,
  individualContactItems,
  organisationApplicantDetailsItems,
  interStateOrganisationDecisionDetailsItems,
  interStateOrganisationsLicenceDetailsItems,
  organisationContactItems,
  getStepNumberWithFloraFaunaUrl,
  getStepNumberIndWithImportExportUrl,
  getStepNumberOrgWithImportExportUrl
};
